import { AfterViewInit, Directive, ElementRef, EventEmitter, NgZone, Output } from '@angular/core';

@Directive({
  selector: '[deferVizible]'
})
export class DeferVizibleDirective implements AfterViewInit {
  @Output() public deferVizible: EventEmitter<any> = new EventEmitter();

  private _intersectionObserver?: IntersectionObserver;

  constructor(private _element: ElementRef, private zone: NgZone) {}
  public ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      this._intersectionObserver = new IntersectionObserver((entries) => {
        this.checkForIntersection(entries);
      }, {});
      this._intersectionObserver.observe(<Element>this._element.nativeElement);
    });
  }
  private checkForIntersection = (entries: Array<IntersectionObserverEntry>) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (this.checkIfIntersecting(entry)) {
        this.deferVizible.emit(true);
      } else {
        this.deferVizible.emit(false);
      }
    });
  };
  private checkIfIntersecting(entry: IntersectionObserverEntry) {
    return (<any>entry).isIntersecting && entry.target === this._element.nativeElement;
  }
}
